import 'Vendors/jquery.inview';
import { GetBreakpointWidth } from 'Utils/globals-bp';
//import { searchbarFixedHeight } from 'Utils/ha-searcbar-functions';

export function InitScript_searchResults() {
    if (!searchViewModel.isMultipleResults())
        return;

    $(document).on('click', '.do-search', function (e) {
        e.preventDefault();

        if (!searchViewModel)
            return;

        if (searchViewModel.SearchInProgress())
            return;

        var $searchbar = $('.search');
        if ($searchbar.length < 1)
            return;

        e.stopPropagation();

        var $this = $(this);
        var onlyOnce = $this.attr("data-only-once");
        if (this.hasAttribute("data-only-once") && onlyOnce !== 0 && onlyOnce.toLowerCase() !== "false") {
            onlyOnce = parseInt($this.attr("data-search-once"));
            if (isNaN(onlyOnce))
                onlyOnce = 0;
            if (onlyOnce > 0) {
                return;
            } else {
                $this.attr("data-search-once", onlyOnce + 1);
            }
        }

        // start search, give some time for animation
        var startAutoSearch = function () {
            $('.searchbutton').trigger('click');
            scrollToSearchResults(true);
        };
        setTimeout(startAutoSearch, 300);
    });

    if (searchViewModel.isMultipleResults() && searchViewModel.UseAutoLoad()) {
        // Automatic load more hotels in search result on scrolling
        $(document).on('inview', '.autoload-more-container > .show-more-hotel-results', function (e) {
            if (GetBreakpointWidth() >= 768) {
                //e.preventDefault();
                var $this = $(this);
                //console.log(">>>> $this.data('running') = " + $this.data('running') + " *** $this.data('inview') = " + $this.data('inview') + ' <<filtering ' + searchViewModel.FilterInProgress() + '>>');
                if ($this.data('inview') && !$this.data('running') && !searchViewModel.FilterInProgress()) {
                    $this.data('running', true);
                    function autoloadMoreHotels() {
                        //console.log(">>>> >>> autoloadMoreHotels ");
                        $this.trigger('click'); //$this.click();
                        //if (typeof UpdateSidebarSearchFilter != "undefined") {
                        //    UpdateSidebarSearchFilter(true);
                        //}
                        $this.data('running', false);
                    }
                    //setTimeout(autoloadMoreHotels, 500);
                    autoloadMoreHotels();
                }
                if (!$this.data('inview') && !$this.data('running')) {
                    //console.log(">>>> >>> UpdateSidebarSearchFilter ");
                    //alert("$this.data('running') = " + $this.data('running') + " \n$this.data('inview') = " + $this.data('inview'));
                    if (typeof UpdateSidebarSearchFilter != "undefined") {
                        UpdateSidebarSearchFilter(true);
                        //setTimeout(UpdateSidebarSearchFilter, 250, true);
                    }
                }
            }
        });
    }

    //if (searchViewModel.isMultipleResults() && typeof UpdateSearchMap != "undefined") {
    //    UpdateSearchMap(false);
    //}

};

export function ScrollToTarget(target) {
    if (!target || target.length == 0) return;
    if (!target.match("^#")) {
        if (!target.match("^\.")) {
            target = "." + target;
        }
        if (!target.match(":first$")) {
            target += ":first";
        }
    }

    var holder = $(target);
    if (holder && holder.length > 0) {
        var topMenu = $(".page-nav");
        var offset = 0;
        if (topMenu.length > 0) {
            offset = topMenu.outerHeight() - 1;
        }
        else {
            var searchResults = $("#search-results");
            if (searchResults.length <= 0) {
                searchResults = $(".search-results");
            }
            if (searchResults.length <= 0) {
                searchResults = $("#search-results-container");
            }

            var flgWithSearchBar = searchResults.length > 0 && searchResults.hasClass('anchor') && searchResults.hasClass('with-searchbar');
            if (flgWithSearchBar)
                offset = 90;
            else
                offset = 0;
        }

        $('html, body').stop().animate({
            scrollTop: holder.offset().top - offset
        }, 300);
    }
};

export function scrollToSearchResults(forceScrolling) {
    if (!searchViewModel.RetrievingDataReady()) {
        //console.log("scrollToSearchResults: RetrievingDataReady is false.");
        if (!forceScrolling) return;
    }
    if (!searchViewModel.UseScrollingToResults()) {
        //console.log("scrollToSearchResults: UseScrollingToResults is false.");
        if (!forceScrolling) return;
    }
    var searchResults = $("#search-results");
    if (searchResults.length <= 0) {
        searchResults = $(".search-results");
    }
    if (searchResults.length <= 0) {
        searchResults = $("#search-results-container");
    }
    if (searchResults.length > 0) {
        //console.log("scrollToSearchResults: searchResults.offset().top = " + searchResults.offset().top + " searchbarFixedHeight() = " + searchbarFixedHeight());

        var topMenu = $(".page-nav");
        var topMenuHeight = 0;
        if (topMenu.length > 0) {
            topMenuHeight = topMenu.outerHeight() - 1;
        }
        else {
            var flgWithSearchBar = searchResults.hasClass('anchor') && searchResults.hasClass('with-searchbar');
            if (flgWithSearchBar)
                topMenuHeight = 0;
            else
                topMenuHeight = 80;
        }

        $('html, body').stop().animate({
            //scrollTop: searchResults.offset().top - searchbarFixedHeight() - 16
            //scrollTop: searchResults.offset().top /*Used CSS Padding/Marging for anchor position*/
            scrollTop: searchResults.offset().top - topMenuHeight/* - 80*/ // disabled -80px for all versions
        }, 300);
    }
    else {
        //console.log("scrollToSearchResults: '#search-results' no found.");
    }
};

export function scrollToSearchResultByPageId(id) {
    let $el = $('#hotel-page-id-' + id);
    if ($el.length > 0) {
        let $scrollContainer = $el.closest('#sidebarMapResult');

        let pos = $el.offset().top - $scrollContainer.offset().top + $scrollContainer.scrollTop();

        $scrollContainer.stop().animate({
            scrollTop: pos
        }, 1000);
    }
};



export function clampHotelDescription() {
    //var elements = document.getElementsByClassName("clamp-roomdesc");
    ////var readMore = '<a data-bind="attr: { href: Slug() + $parent.GetHotelSearchQuery() }" target="_blank">' + '<div class="photobox">Read more</div></a>';
    //
    //Array.prototype.forEach.call(elements, function (element, index, array) {
    //    var link = $(element).next();
    //    var text = link.text();
    //    var readMore = "<span>...</span> "+link.outerHTML();
    //    link.hide();
    //
    //    element.innerHTML = text + element.innerHTML;
    //
    //    var clamping = $clamp(element, { clamp: 2, useNativeClamp: false, splitOnChars: ['.', ',', ' ']/*, truncationChar: '_', truncationHTML: readMore */});
    //    $(element).find('.clamp-link').show();
    //    var txt1 = clamping.originalText;
    //    var txt2 = clamping.clampedText;
    //});
};

export function AfterRenderSearchResults() {
    //console.log('AfterRenderSearchResults');
    /*if (GetBreakpointWidth() >= 1024) {
        if (typeof UpdateSidebarSearchFilter != "undefined") {
            UpdateSidebarSearchFilter(true);
            //setTimeout(UpdateSidebarSearchFilter, 16, true);
        }
    }*/
};

export function AfterForeachSearchResults(hotelResults) {
    //console.log('AfterForeachSearchResults >> ' + (hotelResults != null ? hotelResults.length : -1) + ' <<filtering ' + searchViewModel.FilterInProgress() + '>>');



    if (GetBreakpointWidth() >= 1024 && !searchViewModel.FilterInProgress()) {
        if (typeof UpdateSidebarSearchFilter != "undefined") {
            UpdateSidebarSearchFilter(true);
            //setTimeout(UpdateSidebarSearchFilter, 16, true);
        }
    }

};

export function AfterForeachSearchResultsMap(hotelResults) {
    var selectedMarkerPageId = searchViewModel.SelectedMarkerPageId();
    if (selectedMarkerPageId) {
        setTimeout(function () {
            scrollToSearchResultByPageId(selectedMarkerPageId);
        }, 300);
    }

};
